<template>
  <header id="header" class="sticky top-0 z-50">
    <nav class="bg-[#00423D] flex items-center justify-between pt-3 pb-2">
      <div class="flex items-center">
        <div class="logo">
          <RouterLink to="/steps/getting-started/welcome">
            <img src="@/assets/logo-aaf.svg" alt="logo" />
          </RouterLink>
        </div>
        <ul class="navigation flex items-center ml-[5rem]">
          <li v-for="item in navigationItems" :key="item.name" class="mr-[1.5rem] relative" :class="{ 'active': item.active }">
            <router-link :to="item.path" class="text-[#F5F6FA] font-semibold text-[16px] py-[1.5rem] inline-block no-underline">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="flex items-center">
       
        <TeamMembers />

        <div class="flex items-center ml-[2.25rem] pr-[0.75rem]">
          <a href="https://barberandassociatesllc.atlassian.net/servicedesk/customer/portal/1" target="_blank" rel="noopener noreferrer" class="text-[#FFFFFF] font-semibold text-[14px]">Help</a>
          <router-link to="/settings" class="text-[#FFFFFF] font-semibold text-[14px] ml-[9.5px] no-underline">Settings</router-link>
          <button class="text-[#FFFFFF] font-semibold text-[14px] ml-[9.5px]" @click="onLogoutClick()">Logout</button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import TeamMembers from './TeamMembers.vue';

//v Vue Router
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

//v Pinia Store: Auth
import { useAuthStore } from "@/stores/auth";
const authStore = useAuthStore();

const baseNavigationItems = [
  { name: 'Fundraising Plan', path: '/steps/getting-started/welcome' },
  { name: 'Fundraising Resources', path: '/fundraising-collateral' },
];

// Computed property for navigation items with active state
const navigationItems = computed(() => {
  const currentPath = route.path;
  
  return baseNavigationItems.map((item) => {
    let isActive = false;
    
    if (item.path === '/steps/getting-started/welcome') {
      // Fundraising Plan: match any path starting with /steps/
      isActive = currentPath.startsWith('/steps/');
    } else if (item.path === '/fundraising-collateral') {
      // Fundraising Resources: match exact path or paths starting with /fundraising-collateral/
      isActive = currentPath === item.path || currentPath.startsWith('/fundraising-collateral/');
    }
    
    return {
      ...item,
      active: isActive,
    };
  });
});

function onLogoutClick() {
  authStore.logout();
  router.push({ name: "login" });
}
</script>

<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.active a {
  color: #F5F6FA;
}

ul.navigation li.active:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  height: 8px;
  background: #fff;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
</style>
